<div [attr.id]="titleId" class="hvac-rich-text-container">
    <div *ngIf="data?.Content?.title" class="hvac-rich-text-container-title-container">
        <h3 class="hvac-rich-text-container-title" [innerHTML]="data?.Content?.title | richText"></h3>
    </div>
    <div *ngIf="data?.Content?.subTitle" class="hvac-rich-text-container-subtitle-container">
        <h4 class="hvac-rich-text-container-subtitle" [innerHTML]="data?.Content?.subTitle | richText"></h4>
    </div>
    <hvac-rich-text [class]="'hvac-environment-' + env" [fragments]="data?.Content?.text?.Fragments"></hvac-rich-text>
</div>
